import axios from 'axios';

export default {
  recalculate: (params) => axios.post('/api/v1/avg/recalculation', params),
  get: () => axios.get(`/api/v1/avg/recalculation`),
};
